module.exports = __webpack_public_path__ + "sflyssofe.91b6126c68.svg";